import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {RootState} from './store'
import { IUser } from '../interface/IUser'

const localAllUserData = sessionStorage.getItem('AllUserData') !== null ? 
JSON.parse(sessionStorage.getItem('AllUserData') || ''):[]  as IUser[] ;
const AllUserSlice = createSlice({
  name: 'AllUserData',
   initialState: [
    ...localAllUserData
   
  ] as IUser[],
  reducers: {
    incrementAllUsers: (state, action: PayloadAction<IUser[]>) => {   
       state = [] as IUser[];
       action.payload.forEach(function(usr) {
        state.push(usr as IUser);
    });
    sessionStorage.setItem('AllUserData', JSON.stringify(state));  
       return state;
    }
  },
})



// Action creators are generated for each case reducer function
export const {  incrementAllUsers } = AllUserSlice.actions
export const allUserData = (state: RootState)=>state
export default AllUserSlice.reducer